module.exports = __webpack_public_path__ + "img/Anhänger_O_B_2t.b1674007.svg";